import React, {Component} from 'react'
import { connect } from 'react-redux'
import { getListUserSellV2 } from '../../actions/sellRequestAction'
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from 'react-loading-animation';

import { Alert, Col, Row, Card, CardBody } from 'reactstrap';

import { CardHeaderWithToolbars,Title } from '../../components/Card/CardHeaderWithToolbars';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import Toolbars from './Filters/Toolbars';
import FilterPanel from './sellRequests/FilterPanel';
import privateView from '../../components/hocs/privateView';
import List from './sellRequests/List'
import DropdownProductCategories from '../../components/Dropdowns/DropdownProductCategories';
import { Th } from '../../components/Tbl';
import Analytics from "../../services/Analytics";
import ModalBulkUpload from './Modals/ModalBulkUpload';
import { doBulkStock, doUploadBulkStock } from '../../actions/bulkUploadStockAction';
import ModalCreateRequest from './Components/ModalCreateRequest';
import AlertNotFound from '../../components/Card/AlertNotFound';

const defaultParams = {
  per_page : 100,
  status: ''
}

const DEFAULT_ROUTE = '/sell_request';

class SellRequests extends Component {
	constructor(props) {
		super(props)
		this.state={
			_params:{
        ...defaultParams
      },
      _modalBulkUploadOpen: false,
      _list: [],
      _hasMore: true,
      _nextCursor: null,
      _resetList: true,
      _filterOpen: false,
      _successAlertOpen: false,
      _selectedCategory: null,
      isOpenModalCreateRequest: false,
      isDataLoaded: false
    }
    this._handleApplyFilter = this._handleApplyFilter.bind(this);
    this._refreshList = this._refreshList.bind(this);
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._handleParamsChange = this._handleParamsChange.bind(this);
    this._handleCheckedChange = this._handleCheckedChange.bind(this);
    this._handleParamsChangeAndSubmit = this._handleParamsChangeAndSubmit.bind(this);
    this._handleStatusChange = this._handleStatusChange.bind(this);
    this._handleRemoveSuccessAlert = this._handleRemoveSuccessAlert.bind(this);
    this._handleCategoryChanged = this._handleCategoryChanged.bind(this);
    this._handleToggleModalBulkUpload = this._handleToggleModalBulkUpload.bind(this);
  }

  componentDidMount(){
    const { email } = this.props.injectedProps;
    this._refreshList();
    Analytics.recordPageView('sell_request_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  componentDidUpdate(prevProps){
    const { isFetch } = this.props.sellRequest;
    if(prevProps.sellRequest.isFetch !== isFetch && !isFetch){
      if(this.props.sellRequest.error === null){
        const { data, has_more, next_cursor } = this.props.sellRequest.list;
        const { _resetList } = this.state;
        this.setState({
          _list: _resetList ? [...data] : [...this.state._list, ...data],
          _hasMore: has_more,
          _nextCursor: next_cursor,
          _resetList: false,
          isDataLoaded: true
        })
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if(nextProps.sellRequest.isSubmit&&nextProps.sellRequest.isSubmit!==this.props.sellRequest.isSubmit){
      return false;
    }
    return true;
  }

  _handleApplyFilter(payloadFilter){
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter,
      },
      _list: [],
      _hasMore: true,
      _nextCursor: null,
      _resetList: true
    },()=>this._getList(this.state._params));
  }

  _getList(rawParams = {}){
    const { _nextCursor, _resetList } = this.state;
    if(_nextCursor && !_resetList){
      return this.props.getList({params: { cursor: _nextCursor }});
    }
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .forEach(key=> params[key] = rawParams[key]);
    return this.props.getList({params});
  }

  _refreshList(){
    this.setState({
      _params:{ ...defaultParams },
      _list: [],
      _hasMore: true,
      _nextCursor: null,
      _resetList: true
    },() => {
      this._getList(this.state._params);
    });
  }

  _handleResetFilter(e){
    e.preventDefault();
    this.setState({
      _params:{ ...defaultParams },
      _isResetFilter: true,
      _selectedCategory: null,
      _list: [],
      _hasMore: true,
      _nextCursor: null,
      _resetList: true
    },()=>this._getList(this.state._params));
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }

  _handleToggleFilterPanel(e){
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _toggleFilterPanel(){
    this.setState({_filterOpen:!this.state._filterOpen})
  }

  _handleParamsChange(e) {
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({_params});
  }

  _handleCheckedChange(e) {
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({_params});
  }

  _handleParamsChangeAndSubmit(e){
    const { ..._params } = this.state._params;
    _params[e.target.name] = e.target.value;
    this.setState({
      _params,
      _list: [],
      _hasMore: true,
      _nextCursor: null,
      _resetList: true
    },()=>{
      this._getList(this.state._params);
    });
  }

  _handleNextPage = () => {
    const { isFetch } = this.props.sellRequest;
    const { _hasMore, _list } = this.state;
    if(!isFetch && _hasMore && _list.length > 0){
      this._getList(this.state._params);
    }
  }

  _handleStatusChange(e,{id, product_variant_id, status}){
    if(!this.props.sellRequest.isSubmit){
      const { _localUpdateStatus } = this.state;
      const items = _localUpdateStatus.filter(item=>item.id!==id);
      this.setState({
        _localUpdateStatus: [...items, { id, newStatus: e.target.value, oldStatus: status }]
      })
      this.props.updateStatus(id, {product_variant_id,status:e.target.value})
    }
  }

  _handleRemoveSuccessAlert(){
    this.setState({
      _successAlertOpen: !this.state._successAlertOpen
    })
  }

  async _handleCategoryChanged(category){
    await this.setState({
      _selectedCategory: category === ''? null: category.label,
      _params: {
        ...this.state._params,
        category_id: category === ''? category: category.value,
      },
      _list: [],
      _hasMore: true,
      _nextCursor: null,
      _resetList: true
    });
    const { _params } = this.state;
    this._getList(_params);
  }

  _handleToggleModalBulkUpload(){
    this.setState({
      _modalBulkUploadOpen: !this.state._modalBulkUploadOpen
    })
  }

  _renderLoading = () => (
    <div style={{display: 'flex', padding: '1.25rem'}}>
      <Loading/>
    </div>
  )

  _renderEndMessage = () => {
    const { _list } = this.state;
    return _list.length > 0 ? (
      <p style={{textAlign: 'center'}}>
        <b>Yay! You have seen it all</b>
      </p>
    ) : <AlertNotFound/>
  }

  render() {
    return (
      <div className="animated fadeIn">
        <ModalBulkUpload
          isOpen={this.state._modalBulkUploadOpen}
          onToggle={this._handleToggleModalBulkUpload}
          dataBulk={this.props.bulkUploadStock}
          refreshAfterDone={true}
          onRefresh={this._refreshList}
          onClear={this.props.clearBulkForm}
          onUpload={this.props.uploadBulk}
          onSubmit={this.props.postBulkUpload}
        />
        <ModalCreateRequest
          isOpen={this.state.isOpenModalCreateRequest}
          onClose={()=>{
            this.setState({isOpenModalCreateRequest: false});
          }}
        />
        <Row>
          <Col xs="12">
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Sell & Consignment Request List</span>
                </Title>
                {this.state.isDataLoaded && <Toolbars
                  isOpen={this.state._filterOpen}
                  onClickAdd={()=>{
                    this.setState({isOpenModalCreateRequest: true});
                  }}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onToggleModalBulkUpload={this._handleToggleModalBulkUpload}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />}
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel
                  {...this.state._params}
                  isOpen={this.state._filterOpen}
                  onApplyFilter={this._handleApplyFilter}
                  isReset={this.state._isResetFilter}
                  onResetFilterCallback={()=>this.setState({_isResetFilter: false, _filterOpen: false})}
                />
              </FilterContainer>
              <CardBody>
                <Alert color="info" isOpen={this.state._successAlertOpen} toggle={this._handleRemoveSuccessAlert}>
                  <strong>Your list has been updated,</strong> maybe it can affect with your filter. Click (<i className="fa fa-refresh"></i>) button to refresh list.
                </Alert>
                <InfiniteScroll
                  dataLength={this.state._resetList ? 0 : this.state._list.length}
                  next={this._handleNextPage}
                  hasMore={this.state._hasMore}
                  scrollThreshold={0.95}
                  loader={this._renderLoading()}
                  endMessage={this._renderEndMessage()}
                >
                  <List
                    innerRefs={tableRef => this.tableRef = tableRef}
                    data={this.state._list}
                    isLoading={this.state._resetList && this.props.sellRequest.isFetch}
                    statusCode={this.props.sellRequest.list.status_code}
                    defaultRoute={DEFAULT_ROUTE}
                    onRenderHeader={()=>(
                      <tr>
                        <Th>No.</Th>
                        <Th>
                          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                            <p style={{marginRight: 10, marginBottom: 0}}>
                              Product
                              {
                                this.state._selectedCategory !== null?
                                <span style={{display: 'block', fontSize: '.5rem'}}>{this.state._selectedCategory}</span>
                                : null
                              }
                            </p>
                            <DropdownProductCategories
                              value={this.state._params.catgory_id}
                              onCategoryChanged={this._handleCategoryChanged}
                            />
                          </div>
                        </Th>
                        <Th>Type</Th>
                        <Th style={{ minWidth: '170px' }}>Express Lowest Ask</Th>
                        <Th>Price</Th>
                        <Th>Updated</Th>
                        <Th>Status</Th>
                        <Th>Action</Th>
                      </tr>
                    )}
                  />
                </InfiniteScroll>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps=({sellRequest, bulkUploadStock, auth: { isFetch, isLogged, roles, id, email }})=> {
	return {
    sellRequest,
    bulkUploadStock,
    guardData: { isFetch, isLogged, roles, id, email }
	}
}
const mapDispatchToProps=(dispatch)=> {
	return {
		getList:(filter)=>dispatch(getListUserSellV2(filter)),
    postBulkUpload:(payload) => dispatch(doBulkStock(payload)),
    uploadBulk:(file,folder) => dispatch(doUploadBulkStock(file,folder)),
    clearBulkForm:()=>dispatch({type:'CLEAR_BULK_STOCK'}),
	}
}
const enchance = connect(mapStateToProps,mapDispatchToProps);
export default enchance(privateView(SellRequests, ['supervisor','sale_supervisor','cashier']))
